import { createContext } from "react";

const AuthorizationChangedDialogContext = createContext();

export default AuthorizationChangedDialogContext;
